export enum Literals {
  Chat = 'chat',
  EnterMessage = 'enterMessage',
  ReportMessage = 'reportMessage',
  NotInterested = 'notInterested',
}
